<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import AssetTag from '@/components/asset/AssetTag.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import IconTextButton from '@/components/ui/button/IconTextButton.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AppDialog from '@/components/app/AppDialog.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import Input from '@/components/ui/form/FormInput.vue';
import AppSelect from '@/components/app/AppSelect.vue';
import AppTextField from '@/components/app/AppTextfield.vue';
import AssetPlayer from './AssetPlayer.vue';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import AssetApi from '@/api/asset/AssetApi';
import SocialApi from '@/api/social/SocialApi';
export default {
    components: {
        AssetTag,
        TextButton,
        IconTextButton,
        TextButtonBlock,
        AppDialog,
        CustomSwitch,
        Input,
        AppSelect,
        AssetPlayer,
        AppSnackbar,
        AppTextField
    },
    data() {
        return {
            showBtn: false,
            type: null,
            idx: 0,
            playVal: false,
            encodeList: [],
            thumbnailList: [],
            delConfirm: false,
            selIdx: 0,
            customSize: false,
            customSizeEndIdx: 0,
            temp: null,
            cImg: null,
            assetInfo: {},
            encodeInfo: {},
            smil_url: null,
            smil_player_url: null,
            tagVal: null,
            chips: [],
            datas: [],
            items: [],
            name: null,
            explanation: null,
            initGroups: [],
            poster: null,
            thumnail_c: null,
            tags: [],
            timeout: null,
            stateCheck: false,
            checkStatusVal: null,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            snackbarErrorText: '',
            selDatas: null,
            selItems: [],
            updateLoading: false,
            initTagLength: null,
            newTag: [],
            selTags: [],
            secure: 0,
            tbloading: false,
            // Social upload history
            socialHistory: [],
            socialHistoryLoading: false,
            socialHistoryError: null,
            defaultSocialThumb: require('@/styles/socialimage.png'),
            platformIconMap: {
                youtube: require('@/styles/youtube.png'),
                YouTube: require('@/styles/youtube.png'),
                instagram: require('@/styles/instgram.png'),
                Instagram: require('@/styles/instgram.png'),
                default: require('@/styles/socialimage.png'),
            },
            // UI-only: AI Subtitles
            aiStatus: 'before', // 'before' | 'idle' | 'generating' | 'done' | 'failed'
            subtitleFormat: 'text', // 'text' | 'srt'
            srtExists: false,
            srtFileName: null,
            aiTextCues: [],
            showSubtitleEditor: false,
            editCues: [],
            aiPanel: 0,
            transcriptError: null,
            transcriptLoading: false,
            transcriptDownloadUrl: null,
            transcriptTimer: null,
            snackbarTimer: null,
            aiImg: require('@/styles/ai.png'),
            showSrtUploadConfirm: false,
        }
    },
    methods: {
        ...mapActions('asset', ['updateFlag' ,'deleteTag', 'fetchDetailInfo', 'uploadTask', 'deleteTask', 'updateDistribution', 'fetchGroupList', 'groupingSingle', 'updateDatas', 'addTag']),
        ...mapActions('group', ['updateGroupId']),
        async fetchSocialHistory() {
            if (!this.detailId) {
                this.socialHistory = [];
                return;
            }
            if (!this.canUseSocialPublish) {
                this.socialHistory = [];
                this.socialHistoryError = this.$store.getters.t
                    ? this.$store.getters.t('social.history.locked.current_plan')
                    : '현재 요금제에서는 소셜 업로드 로그가 제공되지 않습니다.';
                this.socialHistoryLoading = false;
                return;
            }
            this.socialHistoryLoading = true;
            this.socialHistoryError = null;

            try {
                const tasks = await SocialApi.fetchPublishTasks({
                    asset_id: this.detailId,
                    include_hidden: true,
                });
                this.socialHistory = (tasks || [])
                    .map(task => this.mapTaskToHistory(task))
                    .filter(item => item !== null);
            } catch (error) {
                console.error('Failed to load social history', error);
                const fallback = '소셜 업로드 이력을 불러오지 못했습니다.';
                this.socialHistoryError = this.$store.getters.t
                    ? this.$store.getters.t('social.history.error.fetch_history')
                    : fallback;
                this.socialHistory = [];
            } finally {
                this.socialHistoryLoading = false;
            }
        },
        mapTaskToHistory(task) {
            if (!task) return null;

            const integration = task.integration || {};
            const platform = integration.platform || {};
            const payload = task.payload || {};
            const settings = (integration.settings && typeof integration.settings === 'object')
                ? integration.settings
                : {};
            const credentials = (integration.credentials && typeof integration.credentials === 'object')
                ? integration.credentials
                : {};

            const privacyMeta = this.getPrivacyMeta(payload.privacy);
            const statusMeta = this.getStatusMeta(task.status, privacyMeta);

            const channelName = integration.external_name
                || settings.title
                || platform.name
                || '-';

            const subtitle = settings.username
                || integration.channel_url
                || credentials.email
                || integration.external_id
                || '-';

            const thumbnail = settings.thumbnail_url || this.defaultSocialThumb;
            const postedAtSource = task.finished_at || task.created_at;
            const channelUrl = this.resolveChannelUrl(integration, settings, credentials);
            const videoInfo = this.resolveVideoInfo(task, platform);

            return {
                id: task.id,
                platform: platform.name || platform.key || 'Unknown',
                platformKey: platform.key || platform.name || 'default',
                channel: channelName,
                subtitle,
                channelUrl,
                videoUrl: videoInfo.url,
                videoLabel: videoInfo.label,
                thumbnail,
                statusLabel: statusMeta.label,
                chipColor: statusMeta.color,
                postedAt: this.formatDateTime(postedAtSource),
            };
        },
        resolveChannelUrl(integration, settings = {}, credentials = {}) {
            if (!integration) return '';
            if (!settings && integration.settings) {
                settings = integration.settings;
            }
            if (!credentials && integration.credentials) {
                credentials = integration.credentials;
            }
            return integration.channel_url
                || settings.channel_url
                || credentials.channel_url
                || '';
        },
        resolveVideoInfo(task, platform = {}) {
            const platformKey = (platform.key || platform.name || '').toLowerCase();
            if (platformKey !== 'youtube') {
                return { url: '', label: '' };
            }

            const typeKey = (task?.type || '').toLowerCase();
            const remoteId = task?.remote_identifier
                || task?.response?.video_id
                || task?.response?.broadcast_id;

            if (!remoteId) {
                return { url: '', label: '' };
            }

            const url = this.buildYoutubeWatchUrl(remoteId);
            const labelKey = typeKey === 'live_sync'
                ? 'social.history.live_url_label'
                : 'social.history.video_url_label';

            const label = this.$store.getters.t
                ? this.$store.getters.t(labelKey)
                : (typeKey === 'live_sync' ? '라이브 URL' : '영상 URL');

            return { url, label };
        },
        buildYoutubeWatchUrl(videoId) {
            return videoId ? `https://www.youtube.com/watch?v=${videoId}` : '';
        },
        getPrivacyMeta(privacy) {
            const translate = key => (this.$store.getters.t ? this.$store.getters.t(key) : key);
            const key = (privacy || '').toLowerCase();
            switch (key) {
                case 'public':
                    return { label: translate('social.upload.visibility.public'), color: 'success' };
                case 'unlisted':
                    return { label: translate('social.upload.visibility.unlisted'), color: 'warning' };
                case 'private':
                    return { label: translate('social.upload.visibility.private'), color: 'grey' };
                default:
                    if (!key) {
                        return { label: translate('social.upload.visibility.private'), color: 'grey' };
                    }
                    return { label: privacy, color: 'grey' };
            }
        },
        getStatusMeta(status, privacyMeta) {
            const translate = key => (this.$store.getters.t ? this.$store.getters.t(key) : key);
            const key = (status || '').toLowerCase();
            switch (key) {
                case 'completed':
                    return { label: privacyMeta.label, color: privacyMeta.color };
                case 'processing':
                    return { label: translate('social.history.status.processing'), color: 'primary' };
                case 'queued':
                    return { label: translate('social.history.status.queued'), color: 'grey' };
                case 'failed':
                    return { label: translate('social.history.status.failed'), color: 'red' };
                case 'cancelled':
                    return { label: translate('social.history.status.cancelled'), color: 'grey darken-1' };
                default:
                    return { label: status || translate('social.history.status.unknown'), color: 'grey' };
            }
        },
        formatDateTime(value) {
            if (!value) return '-';
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return value;
            }
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const hh = String(date.getHours()).padStart(2, '0');
            const mi = String(date.getMinutes()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
        },
        getPlatformIcon(item) {
            const key = item?.platformKey;
            if (key && this.platformIconMap[key]) {
                return this.platformIconMap[key];
            }
            const name = item?.platform;
            if (name && this.platformIconMap[name]) {
                return this.platformIconMap[name];
            }
            return this.platformIconMap.default;
        },
        formatLinkHref(url) {
            if (!url || typeof url !== 'string') return '#';
            const trimmed = url.trim();
            if (!trimmed) return '#';
            return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
        },
        truncateLinkText(url, limit = 42) {
            if (!url || typeof url !== 'string') return '';
            const trimmed = url.trim();
            return trimmed.length > limit ? `${trimmed.slice(0, limit)}…` : trimmed;
        },
        playVideo(){
            // console.log("open")
            this.playVal = true;
        },
        closeVideo(){
            // console.log("close")
            this.playVal = false;
        },
        copyBtn(val){
            // console.log("카피 텍스트 : ", val)
            this.$copyText(val)
                .then(() => {
                    this.snackbar = true;
                    this.snackbarText =this.$store.getters.t('텍스트가 복사되었습니다');
                    this.snackbarError = false;
                    setTimeout(() => {
                        this.snackbar = false;
                    }, 2000);
                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        // initPlay(){
        //     console.log("로드 플레이 (modify) setting")
        //     const iframe = this.$refs.iframe;
        //     iframe.onload = () => {
        //         console.log("iframe 로드");
        //         const video = iframe.contentWindow.document.querySelector('video');
        //         if (!video) return;
        //     };
            

        // },
        // loadPlay(){
        //     console.log("로드 플레이 (modify)")
        //     const iframe = this.$refs.iframe;
        //     const video = iframe.contentWindow.document.querySelector('video');
        //     if (!video) return;

        //     video.autoplay = true;
        //     // video.play();
        //     video.addEventListener('loadedmetadata', () => {
        //         video.play();
        //     });                

        //     // const iframe = this.$refs.iframe;
        //     // if (!iframe || !iframe.contentWindow || !iframe.contentWindow.document) return;
        //     // iframe.contentWindow.postMessage({ message: 'playVideo' }, '*');

        //     // window.addEventListener('message', event => {
        //     //     if (event.data === 'playVideo') {
        //     //         console.log("event.data => ", event.data)
        //     //         const video = iframe.contentWindow.document.querySelector('video');
        //     //         if (!video) return;
        //     //         if (video) {
        //     //             video.autoplay = true;
        //     //             video.play();
        //     //         } else {
        //     //             console.error('영상을 찾을 수 없습니다.');
        //     //         }
        //     //     }
        //     // });
        // },
        showInfo(item, index){
            if (this.encodeInfo) {
                // this.type = this.encodeInfo.map(e => e.find(e => e.resolution === item))[0];
                this.type = this.encodeInfo.find(e => e.resolution === item) || [];
                // console.log("this.type => ", this.type)
                this.idx = index;
            }
        },
        showOriginInfo(){
            this.type = null;
        },
        changeThumbnail(data){
            this.playVal = false;
            this.cImg = data;
        },
        uploadThumbnail(event){
           const file = event.target.files[0];
           if(!file) return;

           const reader = new FileReader();
           reader.onload = async (e) => {
                const fileContent = e.target.result;
                const formData = new FormData();
                formData.append('file', file);
                formData.append('asset_id', this.detailId);
                formData.append('aid', this.assetInfo.aid);
                const res = await this.uploadTask(formData);
                if(res === 1){
                    // await this.fetchDetailInfo();
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('썸네일 추가를 성공했습니다.');
                    this.snackbarError = false;
                    await this.loadData();

                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarText = '';
                    }, 3000);
                } else {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('썸네일 추가를 실패했습니다.');
                    this.snackbarError = true;
                    await this.loadData();

                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarText = '';
                        this.snackbarError = false;
                    }, 3000);
                }
            } 
            reader.readAsText(file);

            // this.snackbar = true;
            // this.snackbarText = this.$store.getters.t('썸네일 추가를 성공했습니다.');
            // this.snackbarError = false;

            // setTimeout(() => {
            //     this.loadData();
            //     this.snackbar = false;
            //     this.snackbarText = '';
            // }, 3000);
        },
        async deleteThumbnail(index){
            this.tbloading = true;
            const url = this.thumbnailList.pop().thumbnail360;

            let check;
            if(url === this.cImg){ 
                check = false;
            }
            const params = {
                url: url,
                check: check,
                asset_id: this.detailId
            }

            this.thumbnailList.splice(index, 1);

            const res = await this.deleteTask(params);
            // this.closeDialog('delConfirm');
            if(res === 1){
                this.tbloading = false;
                this.closeDialog('delConfirm');

                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('썸네일 파일 삭제를 성공했습니다.');
                this.snackbarError = false;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = '';
                }, 3000);
            } else {
                this.tbloading = false;
                this.closeDialog('delConfirm');

                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('썸네일 파일 삭제를 실패했습니다.');
                this.snackbarError = true;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = '';
                    this.snackbarError = false;
                }, 3000);
            }
        },
        showdelConfirmation(index){
            this.selIdx = index;
            this.delConfirm = true;
        },
        async closeDialog(dialogName){
            this[dialogName] = false;
        //    await this.fetchDetailInfo();
            await this.loadData();
            
        },

        // ===== Transcript helpers =====
        async triggerSubtitleGeneration(){
            if (!this.canUseAiTranscript) {
                const message = this.$store.getters.t
                    ? this.$store.getters.t('ai.subtitle.locked.toast')
                    : '현재 무료 플랜에서는 AI 자막 기능을 사용할 수 없습니다. 플랜을 업그레이드해 자동 자막 생성을 이용해 보세요.';
                this.showSnackbarMessage(message, true);
                return;
            }
            if (!this.detailId || this.transcriptLoading) {
                return;
            }
            this.transcriptLoading = true;
            this.clearTranscriptTimer();
            try {
                await AssetApi.requestTranscript(this.detailId);
                this.aiStatus = 'generating';
                this.srtExists = false;
                this.srtFileName = null;
                this.transcriptDownloadUrl = null;
                this.aiTextCues = [];
                this.transcriptError = null;
                const message = this.$store.getters.t ? this.$store.getters.t('ai.subtitle.toast.started') : '자막 생성이 시작되었습니다.';
                this.showSnackbarMessage(message);
                this.scheduleTranscriptRefresh();
            } catch (error) {
                const message = error?.response?.data?.message || (this.$store.getters.t ? this.$store.getters.t('ai.subtitle.error.generate_failed') : '자막 생성에 실패했습니다.');
                this.transcriptError = this.translateTranscriptErrorMessage(message);
                this.showSnackbarMessage(message, true);
            } finally {
                this.transcriptLoading = false;
            }
        },
        async refreshTranscript(silent = false){
            if (!this.canUseAiTranscript) {
                this.resetTranscriptState();
                return;
            }
            if (!this.detailId) {
                return;
            }
            if (!silent) {
                this.transcriptLoading = true;
            }
            this.clearTranscriptTimer();
            try {
                const data = await AssetApi.getTranscript(this.detailId);
                const status = data?.status ?? null;
                this.transcriptError = this.translateTranscriptErrorMessage(data?.last_error ?? null);
                this.transcriptDownloadUrl = data?.download_url ?? null;
                this.aiTextCues = Array.isArray(data?.cues) ? data.cues : [];
                this.srtExists = Boolean(this.transcriptDownloadUrl);
                this.aiStatus = this.mapTranscriptStatus(status, this.srtExists, data?.missing);
                if (data?.missing) {
                    const missingMessage = this.$store.getters.t ? this.$store.getters.t('자막 파일을 찾을 수 없습니다. 다시 생성해 주세요.') : '자막 파일을 찾을 수 없습니다. 다시 생성해 주세요.';
                    this.transcriptError = this.translateTranscriptErrorMessage(missingMessage);
                }
                if (this.aiStatus === 'done') {
                    this.srtFileName = this.assetInfo?.name ? `${this.assetInfo.name}.srt` : `${this.assetInfo?.aid || 'subtitle'}.srt`;
                } else if (this.aiStatus === 'generating') {
                    this.scheduleTranscriptRefresh();
                } else {
                    this.srtFileName = null;
                }
            } catch (error) {
                this.aiStatus = 'before';
                this.srtExists = false;
                this.transcriptDownloadUrl = null;
                this.aiTextCues = [];
                if (!silent) {
                    const message = error?.response?.data?.message || (this.$store.getters.t ? this.$store.getters.t('자막 정보를 불러오지 못했습니다.') : '자막 정보를 불러오지 못했습니다.');
                    this.transcriptError = this.translateTranscriptErrorMessage(message);
                    this.showSnackbarMessage(message, true);
                }
            } finally {
                if (!silent) {
                    this.transcriptLoading = false;
                }
            }
        },
        mapTranscriptStatus(status, hasDownload, missing){
            if (missing) {
                return 'before';
            }
            switch (status) {
                case 'processing':
                case 'queued':
                    return 'generating';
                case 'completed':
                    return hasDownload ? 'done' : 'before';
                case 'failed':
                    return 'before';
                default:
                    return hasDownload ? 'done' : 'before';
            }
        },
        scheduleTranscriptRefresh(delay = 5000){
            this.clearTranscriptTimer();
            this.transcriptTimer = setTimeout(() => this.refreshTranscript(true), delay);
        },
        clearTranscriptTimer(){
            if (this.transcriptTimer) {
                clearTimeout(this.transcriptTimer);
                this.transcriptTimer = null;
            }
        },
        resetTranscriptState(){
            this.clearTranscriptTimer();
            this.aiStatus = 'before';
            this.transcriptDownloadUrl = null;
            this.transcriptError = null;
            this.aiTextCues = [];
            this.srtExists = false;
            this.srtFileName = null;
            this.transcriptLoading = false;
        },
        onUploadSrtClick(){
            const message = this.$store.getters.t ? this.$store.getters.t('SRT 업로드 기능은 준비 중입니다.') : 'SRT 업로드 기능은 준비 중입니다.';
            this.showSnackbarMessage(message, true);
        },
        onSrtSelected(){
            // Reserved for future upload support.
        },
        asSrtText(cues){
            if(!Array.isArray(cues)) return '';
            return cues.map((c, i) => `${i+1}\n${c.start.replace('.', ',')} --> ${c.end.replace('.', ',')}\n${c.text}\n`).join('\n');
        },
        toggleSubtitleEditor(){
            this.showSubtitleEditor = !this.showSubtitleEditor;
            if(this.showSubtitleEditor){
                this.editCues = this.aiTextCues.map(c => ({...c}));
            }
        },
        onTimeInput(idx, field, value){
            const digits = String(value || '').replace(/[^0-9]/g, '');
            const h = digits.slice(0,2).padEnd(2,'0');
            const m = digits.slice(2,4).padEnd(2,'0');
            const s = digits.slice(4,6).padEnd(2,'0');
            const val = `${h}:${m}:${s}`;
            if(this.editCues[idx]) this.$set(this.editCues[idx], field, val);
        },
        addCue(){
            this.editCues.push({ start: '00:00:00', end: '00:00:00', text: '' });
        },
        addCueBelow(idx){
            const insert = {
                start: this.editCues[idx]?.end || '00:00:00',
                end: this.editCues[idx]?.end || '00:00:00',
                text: '',
            };
            this.editCues.splice(idx + 1, 0, insert);
        },
        deleteCue(idx){
            this.editCues.splice(idx, 1);
        },
        splitCue(idx){
            const cur = this.editCues[idx];
            if(!cur) return;
            const originalEnd = cur.end || '00:00:00';
            const startSeconds = this.timeToSeconds(cur.start);
            const endSeconds = this.timeToSeconds(originalEnd);
            if (endSeconds <= startSeconds) {
                return;
            }
            const originalText = (cur.text || '').trim();
            if (!originalText) {
                return;
            }

            const sentenceSplit = originalText.split(/(?<=[.,?!])/).map(t => t.trim()).filter(Boolean);
            let segments = sentenceSplit.length > 1 ? sentenceSplit : null;
            if (!segments) {
                const wordSplit = originalText.split(/\s+/).filter(Boolean);
                if (wordSplit.length < 2) {
                    return;
                }
                segments = [
                    wordSplit.slice(0, Math.ceil(wordSplit.length / 2)).join(' '),
                    wordSplit.slice(Math.ceil(wordSplit.length / 2)).join(' ')
                ];
            }

            const firstText = segments[0] || originalText;
            const secondText = segments.slice(1).join(' ').trim() || originalText;

            const ratio = firstText.length / (firstText.length + secondText.length || 1);
            const midSeconds = startSeconds + (endSeconds - startSeconds) * ratio;
            const mid = this.secondsToTime(midSeconds);

            this.$set(this.editCues, idx, {
                start: this.secondsToTime(startSeconds),
                end: mid,
                text: firstText,
            });

            this.editCues.splice(idx + 1, 0, {
                start: mid,
                end: this.secondsToTime(endSeconds),
                text: secondText,
            });
        },
        mergeWithNext(idx){
            const cur = this.editCues[idx];
            const next = this.editCues[idx+1];
            if(!cur || !next) return;
            cur.end = next.end || cur.end;
            cur.text = (cur.text ? cur.text + ' ' : '') + (next.text || '');
            this.editCues.splice(idx+1, 1);
        },
        async saveEditor(){
            if (!this.detailId) {
                return;
            }

            const cuesPayload = this.editCues.map(cue => ({
                start: (cue.start || '').trim(),
                end: (cue.end || '').trim(),
                text: cue.text ?? '',
            }));

            this.transcriptLoading = true;
            this.clearTranscriptTimer();

            try {
                const data = await AssetApi.updateTranscript(this.detailId, {
                    cues: cuesPayload,
                });

                this.aiTextCues = Array.isArray(data?.cues) ? data.cues : cuesPayload;
                this.srtExists = Boolean(data?.download_url);
                this.transcriptDownloadUrl = data?.download_url || null;
                this.transcriptError = null;
                this.aiStatus = this.mapTranscriptStatus(data?.status ?? null, this.srtExists, data?.missing ?? false);
                this.showSubtitleEditor = false;
                this.showSnackbarMessage(this.$store.getters.t ? this.$store.getters.t('저장되었습니다.') : '저장되었습니다.');
            } catch (error) {
                const message = error?.response?.data?.message || (this.$store.getters.t ? this.$store.getters.t('저장에 실패했습니다.') : '저장에 실패했습니다.');
                this.transcriptError = this.translateTranscriptErrorMessage(message);
                this.showSnackbarMessage(message, true);
            } finally {
                this.transcriptLoading = false;
                if (this.aiStatus === 'generating') {
                    this.scheduleTranscriptRefresh();
                }
            }
        },
        cancelEditor(){
            this.showSubtitleEditor = false;
        },
        async downloadSrt(){
            if (!this.detailId || !this.transcriptDownloadUrl) {
                return;
            }
            try {
                const blob = await AssetApi.downloadTranscript(this.detailId);
                const fileName = this.srtFileName || `${this.assetInfo?.name || this.assetInfo?.aid || 'subtitle'}.srt`;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                const message = error?.response?.data?.message || (this.$store.getters.t ? this.$store.getters.t('SRT 다운로드에 실패했습니다.') : 'SRT 다운로드에 실패했습니다.');
                this.showSnackbarMessage(message, true);
            }
        },
        async deleteSrt(){
            if (!this.detailId || !this.transcriptDownloadUrl) {
                return;
            }
            this.clearTranscriptTimer();
            try {
                await AssetApi.deleteTranscript(this.detailId);
                this.aiStatus = 'before';
                this.srtExists = false;
                this.transcriptDownloadUrl = null;
                this.aiTextCues = [];
                this.transcriptError = null;
                const message = this.$store.getters.t ? this.$store.getters.t('삭제되었습니다.') : '삭제되었습니다.';
                this.showSnackbarMessage(message);
            } catch (error) {
                const message = error?.response?.data?.message || (this.$store.getters.t ? this.$store.getters.t('삭제에 실패했습니다.') : '삭제에 실패했습니다.');
                this.showSnackbarMessage(message, true);
            }
        },
        showSnackbarMessage(message, isError = false, duration = 2000){
            if (this.snackbarTimer) {
                clearTimeout(this.snackbarTimer);
            }
            const formattedMessage = this.translateTranscriptErrorMessage(message) || message;
            this.snackbar = true;
            this.snackbarText = formattedMessage;
            this.snackbarError = isError;
            this.snackbarTimer = setTimeout(() => {
                this.snackbar = false;
                this.snackbarText = '';
                this.snackbarError = false;
                this.snackbarTimer = null;
            }, duration);
        },
        translateTranscriptErrorMessage(message){
            if (message === undefined || message === null) {
                return null;
            }
            const normalized = String(message).trim();
            if (!normalized.length) {
                return null;
            }
            const localized = this.noAudioErrorMessage;
            const lowered = normalized.toLowerCase();
            if (
                normalized === 'ai.transcript.error.no_audio' ||
                normalized === localized ||
                lowered.includes('소리가 없는 영상') ||
                lowered.includes('no audio')
            ) {
                return localized;
            }
            return normalized;
        },
        onUploadSrtClick(){
            if (this.transcriptLoading) {
                return;
            }
            this.showSrtUploadConfirm = true;
        },
        confirmSrtUpload(){
            this.showSrtUploadConfirm = false;
            this.$nextTick(() => this.triggerSrtFileDialog());
        },
        triggerSrtFileDialog(){
            const input = this.$refs.srtFileInput;
            if (input) {
                input.value = '';
                input.click();
            }
        },
        async handleSrtFileSelected(event){
            const file = event?.target?.files?.[0];
            if (!file) {
                return;
            }
            if (!file.name.toLowerCase().endsWith('.srt')) {
                const message = this.$store.getters.t
                    ? this.$store.getters.t('ai.subtitle.srt_upload.invalid_format')
                    : '유효한 SRT 파일을 선택해주세요.';
                this.showSnackbarMessage(message, true);
                event.target.value = '';
                return;
            }
            try {
                const text = await this.readFileAsText(file);
                const cues = this.parseSrtContent(text);
                if (!cues.length) {
                    throw new Error(this.$store.getters.t
                        ? this.$store.getters.t('ai.subtitle.srt_upload.invalid_format')
                        : '유효한 SRT 파일을 선택해주세요.');
                }
                await this.uploadSrtCues(cues, file.name);
            } catch (error) {
                const message = error?.message || (this.$store.getters.t
                    ? this.$store.getters.t('ai.subtitle.srt_upload.error')
                    : 'SRT 파일을 업로드하지 못했습니다.');
                this.showSnackbarMessage(message, true);
            } finally {
                if (event?.target) {
                    event.target.value = '';
                }
            }
        },
        readFileAsText(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const text = typeof reader.result === 'string' ? reader.result : '';
                    resolve(text);
                };
                reader.onerror = () => reject(reader.error || new Error('Failed to read file.'));
                reader.readAsText(file, 'utf-8');
            });
        },
        parseSrtContent(content){
            const normalized = (content || '').replace(/\r\n/g, '\n').trim();
            if (!normalized) {
                return [];
            }
            const blocks = normalized.split(/\n{2,}/);
            const cues = [];
            blocks.forEach(block => {
                const lines = block.split('\n').map(line => line.trim()).filter(Boolean);
                if (!lines.length) {
                    return;
                }
                let index = 0;
                if (/^\d+$/.test(lines[0])) {
                    index++;
                }
                if (index >= lines.length) {
                    return;
                }
                const timeLine = lines[index++];
                const match = timeLine.match(/(\d{2}:\d{2}:\d{2})(?:[,\.](\d{1,3}))?\s*-->\s*(\d{2}:\d{2}:\d{2})(?:[,\.](\d{1,3}))?/);
                if (!match) {
                    return;
                }
                const startSeconds = this.timeToSeconds(`${match[1]}${match[2] ? '.' + match[2] : ''}`);
                const endSeconds = this.timeToSeconds(`${match[3]}${match[4] ? '.' + match[4] : ''}`);
                const text = lines.slice(index).join('\n').trim();
                if (!text) {
                    return;
                }
                cues.push({
                    start: this.secondsToTime(startSeconds),
                    end: this.secondsToTime(endSeconds),
                    text,
                });
            });
            return cues;
        },
        async uploadSrtCues(cues, fileName){
            if (!this.detailId || !Array.isArray(cues) || !cues.length) {
                return;
            }
            this.transcriptLoading = true;
            this.clearTranscriptTimer();
            try {
                const payload = { cues };
                const data = await AssetApi.updateTranscript(this.detailId, payload);
                this.aiTextCues = Array.isArray(data?.cues) ? data.cues : cues;
                this.srtExists = Boolean(data?.download_url);
                this.transcriptDownloadUrl = data?.download_url || null;
                this.transcriptError = null;
                this.aiStatus = this.mapTranscriptStatus(data?.status ?? 'completed', this.srtExists, false);
                this.srtFileName = fileName || this.srtFileName;
                const message = this.$store.getters.t
                    ? this.$store.getters.t('ai.subtitle.srt_upload.success')
                    : 'SRT 파일을 업로드했습니다.';
                this.showSnackbarMessage(message);
            } catch (error) {
                const message = error?.response?.data?.message || (this.$store.getters.t
                    ? this.$store.getters.t('ai.subtitle.srt_upload.error')
                    : 'SRT 파일을 업로드하지 못했습니다.');
                this.transcriptError = this.translateTranscriptErrorMessage(message);
                this.showSnackbarMessage(message, true);
            } finally {
                this.transcriptLoading = false;
            }
        },
        timeToSeconds(time){
            const normalized = (time || '00:00:00').replace(',', '.').trim();
            const parts = normalized.split(':').map(part => part.trim());
            const [h = '0', m = '0', s = '0'] = parts.slice(-3);
            const hours = parseInt(h, 10) || 0;
            const minutes = parseInt(m, 10) || 0;
            const seconds = parseFloat(s) || 0;
            return Math.max(hours * 3600 + minutes * 60 + seconds, 0);
        },
        secondsToTime(totalSeconds){
            const clamped = Math.max(totalSeconds, 0);
            const hours = Math.floor(clamped / 3600);
            const minutes = Math.floor((clamped % 3600) / 60);
            const seconds = clamped - hours * 3600 - minutes * 60;
            const secString = seconds % 1 === 0 ? String(Math.round(seconds)).padStart(2, '0') : seconds.toFixed(3).padStart(6, '0');
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${secString}`;
        },
        async toggleSwitch(){
            const newState = !this.switchState;
            // const folder = this.checkStatusVal === 'uploaded' ? 'upload' : 'encoded';
            // let smil_url_upload;
            // if(this.checkStatusVal === 'upload'){
            //     smil_url_upload = this.assetInfo.Hlsurl;
            // }
            // else {
            //     smil_url_upload = this.smil_url;
            // }
            const params = {
                id: this.detailId,
                aid: this.assetInfo.aid,
                type: this.switchState ? 'unpub' : 'pub',
                smil_url: this.smil_url,
                newState: newState,
                folder: this.checkStatusVal,
            }
           this.$store.commit('asset/setSwitchState', newState);
           const res = await this.updateDistribution(params);
            if(res !== 1){
                this.$store.commit('asset/setSwitchState', !newState);
            }
            // this.$router.go();
            await this.loadData();
        },

        goAsset(){
            this.updateGroupId('all');
            this.updateFlag(false);
            this.$router.push('/asset');
        },

        validateThumbnails(){
            const validationPromises = this.thumbnailList.map(e => 
                this.checkThumbnail(e.thumbnail360)
            );

            Promise.all(validationPromises)
                .then(e => {
                    this.thumbnailList = e.filter(e => e !== null);
                })
                .catch(error => {
                    console.error('error => ', error);
                });
        },

        checkThumbnail(url){
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve({ thumbnail360: url });
                img.onerror = () => resolve(null);
                img.src = url;
            });
        },

        async setAssetInfo(){
            if(sessionStorage.getItem('AccessToken') == null) return;

            this.assetInfo = this.info[0];
            if(this.assetInfo){
                //console.log("원본 => ", this.assetInfo)

                this.checkStatusVal = this.assetInfo?.status;

                // const check = this.assetInfo.status;
                // this.datas = this.assetInfo?.groups?.map(e => e.group_name);
                this.datas = this.assetInfo?.groups?.map(e => e.group_name) ?? [];

                // console.log("그룹 => ", this.groupList)
                this.initGroups = this.datas;

                this.items = Object.values(this.groupList).map(e => e.group_name);
                //   / this.items.splice(0, 'all');
                // this.selItems = Object.values(this.groupList).map(e => e.group_name);
                // this.selItems.unshift("전체 리스트");
                this.name =  this.assetInfo?.name ?? null; 
                this.explanation = this.assetInfo.explanation;
                // this.thumnail_c = this.assetInfo.thumnail_c;
                this.poster = this.assetInfo.image;
                this.tags = this.assetInfo.tag;
                this.initTagLength = this.tags.length;
                this.secure = this.assetInfo.secure;


                // console.log("데이터확인 modifyForm =>",this.assetInfo)

                // 원본 or 인코딩 예외처리
                //console.log("인코딩 파일 확인")
                this.encodeInfo  = this.assetInfo.encodingInfo.map(e => e);
                // if(this.assetInfo.thumnail_element_C == null || !this.assetInfo.thumnail_element_C){
                if(this.assetInfo.thumnail_element_C == null || !this.assetInfo.thumnail_element_C){
                    this.customSize = false;
                    this.customSizeEndIdx = 0;
                }
                else {
                    this.customSize = true;
                    this.customSizeEndIdx = 1;
                }
                // 썸네일 n개
                const url = this.assetInfo.imageUrl;
                // console.log("url => ", url)

                // console.log("url => ", url)
                this.thumbnailList = JSON.parse(this.assetInfo?.image_360 || '[]');
                // console.log("image_360 => ", this.thumbnailList)
                if (this.thumbnailList && this.thumbnailList.length > 0) {
                    const newList = this.thumbnailList.map(e => ({ thumbnail360: url + e }));
                    this.thumbnailList = newList;
                            // const obj = JSON.parse(this.assetInfo.thumnail_element);
                        // console.log("확ㅇ니확인 => ", this.assetInfo)
                        
                    if(this.customSize){
                        if (this.assetInfo && this.assetInfo.thumnail_element_C) {
                            const tmp = JSON.parse(this.assetInfo.thumnail_element_C)[0].url;
                            // const tmp =  Object.values(this.assetInfo.thumnail_element_C).find(e => e).url;
                            // console.log("확ㅇ니확인 => ", tmp)
                            if(tmp){
                                const newImg = { thumbnail360: tmp };
                                this.thumbnailList = [...this.thumbnailList, newImg];
                            }
                        }   
                    }
                    this.validateThumbnails();
                }

                //console.log("썸네일 N => ", this.thumbnailList)

                // 대표 썸네일
                this.cImg = this.assetInfo.image;

                // url 설정
                this.smil_url = this.assetInfo.smil_url;
                this.smil_player_url = this.assetInfo.playUrl;
                // console.log("url 설정 smil_url =>", this.smil_url);
                // console.log("url 설정 smil_player_url =>", this.smil_player_url);

                // 해상도 리스트
                this.encodeList = this.encodeInfo.map(e => e.resolution).filter(e => e !== undefined && e  !== null && e != "");

                // this.stateCheck = this.assetInfo?.encoding_status === 'Published' && this.assetInfo?.status !== 'processing' && this.assetInfo?.upload_v_codec === 'h264';
                const a = this.assetInfo?.encoding_status === 'Published' && this.assetInfo?.status !== 'processing';
                const b = this.assetInfo?.upload_v_codec === 'h264' && this.assetInfo?.status.includes('uploaded');
                const c = this.assetInfo?.upload_v_codec !== 'h264' && this.assetInfo?.status.includes('encoded');
                const d = this.assetInfo?.upload_v_codec === 'h264' && this.assetInfo?.status.includes('encoded');

                this.stateCheck = false;
                if(a){
                    if(b){
                        this.stateCheck = true;
                    }
                    if(c){
                        this.stateCheck = true;
                    }
                    if(d){
                        this.stateCheck = true;
                    }
                } else {
                    this.stateCheck = false;
                }


                // pub/unpub state
                if(this.assetInfo.encoding_status === "Unpublished"){
                    this.temp = false;
                }
                else {
                    this.temp = true;
                }
                //console.log("pub/unpub => ", this.temp)
                this.$store.commit('asset/setSwitchState', this.temp);

                await this.fetchSocialHistory();
            }

        },
        handleEnter(val){
            this.tagVal = val;
            if (this.tagVal.trim() !== '') {
                this.chips.push(this.tagVal.trim());
                this.$nextTick(() => {
                    this.tagVal = '';
                });
            }
        },
        async onClose(val) {
            if(typeof val === 'object'){
                const params = {
                    asset_id: this.detailId,
                    tag_id: val.id
                }
                this.selTags =  [...this.selTags, params];
                const idx = this.tags.indexOf(val);
                if (idx !== -1) {
                    this.tags.splice(idx, 1);
                }

                this.newTag = this.tags;
               
                // const params = {
                //     asset_id: this.detailId,
                //     tag_id: val.id
                // }
                // const res =  await this.deleteTag(params);
                // if(res === 1){
                //     await this.fetchDetailInfo();
                //     setTimeout(() => {
                //         this.snackbar = true;
                //         this.snackbarText = '정보 수정에 성공했습니다.';
                //         this.snackbarError = false;
                //         setTimeout(() => {
                //         this.$router.go();
                //         }, 2000);
                //     }, 1000);
                // }
            }
            else if(typeof val === 'string') {
                const index = this.chips.indexOf(val);
                if (index !== -1) {
                    this.chips.splice(index, 1);
                }
            }
        },
        goToGroupList(val){
            // console.log("전달?", val)
            // this.selDatas = val;

            if(val === this.$store.getters.t('전체 리스트')){
                this.$store.dispatch('group/updateSelectedGroupId', 'all');
                this.$store.dispatch('group/updateSelectedGroupName', this.$store.getters.t('All Groups'));
                this.updateFlag(false);
                this.$router.push({name: 'asset'});
            }

            const found = this.groupList.find(e => e.group_name === val);
            this.selDatas = found.id; 
            // console.log("sel => ", this.selDatas)
            // this.assetInfo.groups
            this.updateGroupId(Number(this.selDatas));
            this.$store.dispatch('group/updateSelectedGroupId', Number(this.selDatas));
            this.$store.dispatch('group/updateSelectedGroupName', val);
            this.updateFlag(true);
            this.$router.push({name: 'asset'});
        },
        selGrouping(val){
            //console.log("전달?", val)
            this.datas = val;
        },
        async loadData(){
            await this.fetchDetailInfo();
            await this.fetchGroupList();
            await this.setAssetInfo();
            if (this.canUseAiTranscript) {
                await this.refreshTranscript();
            } else {
                this.resetTranscriptState();
            }
        },
        isObject(value) {
            return typeof value === 'object' && value !== null && !Array.isArray(value);
        },
        async updateInfo(){
            this.updateLoading = true;
            let result = [];
            // 기본 정보 수정
            const params = {
                asset_id: this.detailId,
                name:  this.name,
                explanation: this.explanation,
                poster: this.currentImage
            }
            const res = await this.updateDatas(params);
            if(res === 1){
                result.push(true);
                //console.log("통과 1")
           }

            // 그룹 정보 수정
            const diff = !this.isEqualCheck(this.datas, this.initGroups);
            if (diff) {
                // 다름
                const tmp = Object.values(this.datas);
                const groupIds = tmp.map(data => {
                    const obj = this.groupList.find(e => e.group_name === data);
                    return obj ? obj.id : null;
                });
                // console.log("groupIds => ", groupIds)

                const params = {
                    asset_id: this.detailId,
                    groupIds: groupIds
                };
                const res = await this.groupingSingle(params);
                if(res === 1){
                    result.push(true);
                    // console.log("통과 2")
                    // v-snackbar
                }
            } 
            else {
                // 같음
            }
           // 태그 정보 수정
            if(this.chips.length > 0){
                const params = {
                    asset_id: this.detailId,
                    tag_names: this.chips
                };
                const res = await this.addTag(params);
                // console.log("addTag res => ", res)
                if(res === 1){
                    result.push(true);
                    //console.log("통과 3")
                }
            }

            // 태그 삭제
            const lengthTag = this.tags.length;
            if(lengthTag != this.initTagLength){
                const res =  await this.deleteTag(this.selTags);
                if(res === 1){
                    result.push(true);
                }
            }   

            const isAllTrue = result.every(e => e === true);
            if(isAllTrue){
                this.updateLoading = false;
                //console.log("통과 4")
                //console.log("isAllTrue 1=> ",isAllTrue)
                
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('정보 수정에 성공했습니다.');
                this.snackbarError = false;
                await this.loadData();
                
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = '';
                }, 3000);
            }
            else {
                //console.log("isAllTrue 2=> ",isAllTrue)
                // this.timeout = 2000;
                // setTimeout(() => {
                //     this.showSnackbarError = true;
                //     this.snackbarErrorText = '정보를 수정하는데 실패했습니다.';
                //     setTimeout(() => {
                //     this.$router.go();
                //     }, this.timeout);
                // }, 1000);
            }
        },
        isEqualCheck(obj01, obj02){
            if (typeof obj01 !== 'object' || typeof obj02 !== 'object') {
                return false;
            }

   
            const keys1 = Object.keys(obj01);
            const keys2 = Object.keys(obj02);

   
            if (keys1.length !== keys2.length) {
                return false;
            }

            for (let key of keys1) {
                if (!this.isEqualCheck(obj01[key], obj02[key])) {
                    return false;
                }
            }
            return true;
        },
        handleInput(val, type){
            // console.log("확인 => ", val, type)

            if(type === 'name'){
                this.name = val;
            }
            else if(type === 'explanation'){
                this.explanation = val;
            }
        },
        // goBack() {
        //     window.history.back();
        // },
        goBackToGroup() {
            const groupId = localStorage.getItem('selectedGroupId');
            const groupName = localStorage.getItem('selectedGroupName');

            if (groupId) {
            this.$store.dispatch('group/updateSelectedGroupId', groupId);
            this.$store.dispatch('group/updateSelectedGroupName', groupName);
            this.$router.push('/asset'); // 에셋 페이지로 이동
            } else {
            this.$router.push('/asset'); // 기본 이동
            }
        }
    },
    watch: {
        cImg: {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.currentImage = newValue;
                }
            },
            immediate: true,
            deep: true
        },
        group_id: {
            async handler(newValue, oldValue) {
                if(newValue !== oldValue){
                    if(newValue !== 'all'){

                        // const params = {
                        //     group_id: newValue,
                        //     page: 1,
                        //     rowsPerPage: 10
                        // };
                        // const res = await this.fetchGroupListItems(params);


                    } else {
                        this.$router.push({name: 'asset'});
                    }
                }
            },
             deep: true,      
            immediate: true
        },
        canUseSocialPublish(newValue, oldValue) {
            if (newValue && !oldValue) {
                this.fetchSocialHistory();
            }
        },
        canUseAiTranscript(newValue, oldValue) {
            if (newValue && !oldValue) {
                this.refreshTranscript(true);
            } else if (!newValue && oldValue) {
                this.resetTranscriptState();
            }
        },
        toIdle() { this.aiStatus = 'idle'; },
        toGenerating() { this.aiStatus = 'generating'; },
        toDone() { this.aiStatus = 'done'; },
    },
    computed: {
        ...mapGetters('asset', ['groupList']),
        ...mapState('asset', ['detailInfo', 'switchState', 'detailId', 'groupList', 'loading']),
        canUseAiTranscript() {
            return this.$store.getters['naviList/hasAiTranscript'];
        },
        canUseSocialPublish() {
            return this.$store.getters['naviList/hasSocialPublish'];
        },
        info(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                return this.detailInfo.map(e => e);
            }
        },
        // checkStatusVal(){
        //     if(this.detailInfo !== null && typeof this.detailInfo !== 'undefined'){
        //         if(this.assetInfo.status === 'uploaded'){
        //             return 'upload';
        //         }
        //         else if(this.assetInfo.status.match(/^encoded\s/)){
        //             return 'encoded';
        //         }
        //         else if(this.assetInfo.status === 'processing'){
        //             return 'processing';
        //         }
        //     }
        //     return null;
        // },
        size(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                if(this.type === null){
                    return this.assetInfo.upload_size;
                }
                else {
                    const data = this.type.size;
                    return data;
                }
            }
        },
        metaInfo(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                if(this.type === null){
                    const tempInfo = {
                            resolution: this.assetInfo.upload_resolution,
                            codec: this.assetInfo.upload_v_codec,
                            bitrate: this.assetInfo.upload_bitrate,
                            size: this.assetInfo.upload_size
                    };
                
                    return tempInfo;
                }
                else {
                    return this.type;
                }
            }
        },
        hasSocialHistory() {
            return Array.isArray(this.socialHistory) && this.socialHistory.length > 0;
        },
        socialHistoryEmptyMessage() {
            if (!this.canUseSocialPublish) {
                return this.$store.getters.t
                    ? this.$store.getters.t('social.history.locked.current_plan')
                    : '현재 요금제에서는 소셜 업로드 로그가 제공되지 않습니다.';
            }
            if (this.socialHistoryError) {
                return this.socialHistoryError;
            }
            return this.$store.getters.t
                ? this.$store.getters.t('social.history.empty')
                : '소셜 업로드 이력이 없습니다.';
        },
        currentImage: {
           get(){
                if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                    //console.log("현재이미지 => ", this.cImg)
                    if (this.cImg && this.cImg.trim() !== "") {
                        return this.cImg;
                    } else {
                        return "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
                    }
                }
           },
           set(newVal){
                this.cImg = newVal;
           }
        },
        getShowCheck(){
            return (index) => {
                if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined') {
                    if(this.customSize && this.customSizeEndIdx === 1 && index === this.thumbnailList.length -1){
                    return true;
                    }
                    return false;
                }
            }
        },
        isDisabled(){
            if (this.detailInfo !== null && typeof this.detailInfo !== 'undefined' && this.assetInfo) {
                if(this.customSizeEndIdx === 0 && !this.customSize){
                    return false;
                }
                return true;
            }
        },
        isShow(){
            if (this.detailInfo !== null  && typeof this.detailInfo !== 'undefined' && this.assetInfo) {
                if(this.customSizeEndIdx === 0 && !this.customSize){
                    return true;
                }
                return false;
            }
        },
        chipClass() {
            if (this.aiStatus === "generating") {
                return "chip--gen";  // 생성 중일 때
            } else if (this.aiStatus === "done") {
                return "chip--done";  // 생성 완료일 때
            } else if (this.aiStatus === "failed") {
                return "chip--failed";  // 생성 실패일 때
            } else if (this.aiStatus === "idle") {
                return "chip--idle";  // 대기 중일 때
            }
            return "chip--idle";  // 기본 상태는 대기 중
            },
            // 상태에 따른 이미지 클래스 동적 할당
            iconClass() {
            if (this.aiStatus === "generating") {
                return "generating";
            } else if (this.aiStatus === "done") {
                return "done";
            } else if (this.aiStatus === "failed") {
                return "";
            }
            return "";  // 기본 상태
            },
            // 상태에 맞는 라벨 반환
            aistatusLabel() {
            const translate = key => (this.$store.getters.t ? this.$store.getters.t(key) : key);
            if (this.aiStatus === "generating") {
                return translate('ai.subtitle.status.generating');
            } else if (this.aiStatus === "done") {
                return translate('ai.subtitle.status.done');
            } else if (this.aiStatus === "failed") {
                return translate('ai.subtitle.status.failed');
            }
            return translate('ai.subtitle.status.pending');  // 기본 상태
            },
        noAudioErrorMessage() {
            return this.$store.getters.t
                ? this.$store.getters.t('ai.transcript.error.no_audio')
                : '소리가 없는 영상입니다. 자막을 생성할 수 없습니다.';
        },
        noAudioErrorHint() {
            return this.$store.getters.t
                ? this.$store.getters.t('ai.transcript.error.no_audio_hint')
                : 'Automatic subtitles cannot be generated without audio. Upload an SRT file or choose another video.';
        },
        isNoAudioTranscriptError() {
            if (!this.transcriptError) {
                return false;
            }
            const normalizedError = (this.transcriptError || '').trim().toLowerCase();
            const normalizedMessage = (this.noAudioErrorMessage || '').trim().toLowerCase();
            if (!normalizedError) {
                return false;
            }
            if (normalizedError === normalizedMessage) {
                return true;
            }
            return normalizedError.includes('소리가 없는 영상') || normalizedError.includes('no audio');
        },

    },
    beforeDestroy(){
        this.clearTranscriptTimer();
        if (this.snackbarTimer) {
            clearTimeout(this.snackbarTimer);
            this.snackbarTimer = null;
        }
    },
    async mounted(){
        await this.loadData()
    },
};
</script>
<template>
    <!--container-->
    <div class="Background">
        <!-- <div :class="appType == 'secure' ? 'Background-webrtc' : 'Background-webrtc-basic'"> -->

        <!--title-->
        <v-row justify="space-between">
            <v-col>
                <h2 class="Title">
                    {{ assetInfo.name }}
                </h2>
            </v-col>
            <!-- <v-col cols="auto">
            <v-select 
                    v-model="selDatas"
                    :items="selItems"
                    outlined
                    dense
                    @input="goToGroupList"
                    style="width: 200px;"
                    :menu-props="{ maxHeight: '200px', bottom: '100px' }"
                    label="그룹리스트로 이동"
                />
            </v-col> -->
        </v-row>

        <v-row>
            <v-col class="modify_left_wraper" style="position: absolute;">
                <div style="position: relative; 
                background-color: black; 
                width: 100%;
                height: 281.25px;
                display: flex; 
                justify-content: center; 
                align-items: center; 
                overflow: hidden;
                border-radius: 12px;">
                    <v-img :src="currentImage" style="height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;" :contain="true">
                        <div class="overlay">
                            <v-icon v-if="stateCheck" style="font-size: 60px;" @click="playVideo">mdi-play-circle</v-icon>
                        </div>
                    </v-img>
                    <AssetPlayer :compType="true" v-if="playVal" :poster="poster" :playVal="playVal" :playUrl="smil_player_url" :playerName="name"  :closeVideo="closeVideo" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" />
                </div>
                <!-- <v-card>
                    <v-toolbar color="black" dark v-if="playVal">
                        <span>{{ name }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeVideo">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <div class="video-container" ref="videoContainer" style="position: relative;">
                        <v-img :src="currentImage" @click="playVideo"></v-img>
                        <div v-if="playVal" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; background-color: rgba(0, 0, 0, 0.7);">
                            <iframe ref="iframe" scrolling="no" :src="smil_player_url" frameborder="0" allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
                        </div>
                    </div>
                </v-card> -->

                

                <!-- <div class="video-container"  ref="videoContainer" @click="playVideo">
                    <v-img :src="currentImage" ></v-img>
                    <iframe v-if="playVal" ref="iframe" scrolling="no" :src="smil_player_url" frameborder="0" allowfullscreen  @load="initPlay" @playing="loadPlay"></iframe>
                </div> -->
                <div class="thumnail">
                    <h3 class="cont_title">
                    {{ $store.getters.t('섬네일') }}
                        <!-- <TextButton :buttonText="'섬네일 편집'" outlined :small="true" class="ml-2"  :buttonClick="() => closeVideo()"/> -->
                            <!-- <TextButton :disabled="!playVal" :buttonText="$store.getters.t ? $store.getters.t('섬네일 편집') : '섬네일 편집'" outlined :small="true" class="ml-2"  @click="closeVideo"/> -->
                    </h3>

                    <div class="thumnail_box">
                        <v-row>
                            <v-col v-show="isShow" class="pr-2" style="width: 66px;">
                                <!-- <v-card :disabled="isDisabled"  class="thumnail_upload" link outlined @click="$refs.fileInput.click();"> -->
                                <!-- <v-card class="thumnail_upload" link outlined @click="$refs.fileInput.click();">
                                    <input type="file" ref="fileInput" style="display: none" @change="uploadThumbnail">
                                    <v-icon class="mdi mdi-image-plus-outline mt-2" small color="#bbb"/><br>
                                    <span>{{ $store.getters.t('섬네일 업로드') }}</span>
                                </v-card> -->
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-card class="thumnail_upload" link outlined v-bind="attrs" v-on="on" @click="$refs.fileInput.click();">
                                        <input type="file" ref="fileInput" style="display: none" @change="uploadThumbnail">
                                        <v-icon class="mdi mdi-image-plus-outline mt-2" small color="#bbb"/>
                                        <br>
                                        <span>{{ $store.getters.t('업로드') }}</span>
                                        </v-card>
                                    </template>
                                    <span>{{ $store.getters.t('클릭하여 섬네일 업로드') }}</span>
                                </v-tooltip>


                            </v-col>
                            
                            <v-col  v-for="(item, index) in thumbnailList" :key="index" style="width: 66px;" class="pr-2">
                                <v-card :style="cImg == item.thumbnail360 ? 'border: 3px solid red;': ''" link outlined @click="changeThumbnail(item.thumbnail360)">
                                    <v-img :src="item.thumbnail360" height="46px"/>
                                    <span v-show="getShowCheck(index)" @click="showdelConfirmation(index)" class="delete-icon" style="margin-top: -4px;"><v-btn elevation="0" x-small icon style="position: absolute;top: 0;right: 0;"><v-icon>mdi-close-circle</v-icon></v-btn></span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div class="mt-5">
                    <h3 class="table_title">
                        {{ $store.getters.t('INFO') }}
                    </h3>
                    <v-simple-table>
                        <template>
                            <thead>
                                <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        {{ $store.getters.t('영상 제목') }}
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span><Input placeholder="name" :value="name" viewType="name" @input="handleInput"/></span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        {{ $store.getters.t('그룹') }}
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <AppSelect :datas="datas" :items="items" @item-selected="selGrouping" style="height: 40px;"></AppSelect>
                                        <!-- <span>{{ assetInfo.groups?.toString() }}</span> -->
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        {{ $store.getters.t('영상 설명') }}
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span><Input :placeholder="$store.getters.t ? $store.getters.t('영상 설명') : '영상 설명'" :value="explanation" viewType="explanation" @input="handleInput"/></span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        {{ $store.getters.t('퍼블리싱') }}
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <!-- <span>{{ switchState }}</span> -->
                                        <CustomSwitch :switchState="switchState" :toggleSwitch="toggleSwitch"/>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        {{ $store.getters.t('보안') }}
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <v-chip small v-if="secure" class="success_chip">ON</v-chip>
                                        <v-chip small v-else disabled>OFF</v-chip>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        {{ $store.getters.t('태그') }}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" class="mdi mdi-help-circle-outline"></v-icon>
                                            </template>
                                            <span>{{ $store.getters.t('텍스트 입력 후, 엔터를 치면 태그가 등록됩니다.') }}</span>
                                        </v-tooltip>
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span><Input :value="tagVal" :placeholder="$store.getters.t ? $store.getters.t('텍스트 입력 후, 엔터를 치면 태그가 등록됩니다.') : '텍스트 입력 후, 엔터를 치면 태그가 등록됩니다.'" viewType="tag" :handleEnter="handleEnter"/></span>
                                        <!-- <v-chip v-for="(chip, index) in chips" :key="index" close @click:close="removeChip(index)">
                                            {{ chip }}
                                        </v-chip> -->
                                        <AssetTag
                                            v-for="(chip, index) in chips"
                                            :name="chip"
                                            :onClose="() => onClose(chip)"
                                            :key="'chip_' + index"
                                            :chipsColor="'#edf5ff'"
                                            class="mt-2 mr-1"
                                            style="color: #006cea;"
                                        ></AssetTag>
                                        <AssetTag
                                            v-for="(tag, index) in tags"
                                            :name="tag.tag_name"
                                            :onClose="() => onClose(tag)"
                                            :key="'tag_' + index"
                                            :chipsColor="'#edf5ff'"
                                            class="mt-2 mr-1"
                                            style="color: #006cea;"
                                        ></AssetTag>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                    </v-simple-table>

                    <div style="display: flex;justify-content: space-between;padding: 24px 0;">
                        <div>
                            <!-- <TextButton buttonText="목록" class="mt-2 mr-2" iconColor="#ccc" icon="mdi-menu" :buttonClick="() => goAsset()"/> -->
                            <!-- <TextButton buttonText="목록" iconColor="#ccc" icon="mdi-menu" @click="goAsset()"/> -->
                            <!-- <TextButton buttonText="목록" iconColor="#ccc" icon="mdi-menu" @click="goBackToGroup()"/> -->
                        </div>
                        <div class="text-right">
                            <TextButton :buttonText="$store.getters.t ? $store.getters.t('수정') : '수정'" :loading="updateLoading" isPrimary @click="updateInfo()"/>
                        </div>
                        
                    </div>
                </div>
            </v-col>
                
            <v-col class="right_wraper" style="margin-left: 500px;">
                <div class="ml-5">
                    <h3 class="table_title">
                        {{ $store.getters.t('플레이 리스트') }}
                    </h3>

                    <v-simple-table>
                        <template>
                        <thead>
                            <tr>
                                <th class="thead_custom_left thead_custom_top pa-3" style="height: 124px;">
                                    <v-row>
                                        <v-col cols="8">
                                            <h4>{{ $store.getters.t('HLS URL') }}</h4>  
                                        </v-col>
                                        <v-col cols="4">
                                            <TextButton :buttonText="$store.getters.t('copy')" :xsmall="true" class="ml-1"
                                            @click="copyBtn(smil_url)" />
                                        </v-col>
                                    </v-row>
                                </th>
                                <th class="thead_custom_right thead_custom_top pa-3">
                                    <span class="text_box" >{{ smil_url }}</span>
                                </th>
                            </tr>
                            <tr>
                                <th class="thead_custom_left pa-3" style="height: 124px;">
                                    <v-row>
                                        <v-col cols="8">
                                            <h4>{{ $store.getters.t('Embedded Player URL') }}</h4>  
                                        </v-col>
                                        <v-col cols="4" style="align-items: center;display: flex;">
                                            <TextButton :buttonText="$store.getters.t('copy')" :xsmall="true" class="ml-1"
                                            @click="copyBtn(smil_player_url)" />
                                        </v-col>
                                    </v-row>
                                </th>
                                <th class="thead_custom_right pa-3">
                                    <span class="text_box">{{ smil_player_url }}</span>
                                </th>
                            </tr>
                        </thead>
                    </template>
                </v-simple-table>

                </div>

                <!-- AI Subtitles -->
                <div class="ml-5 mt-8 ai-subtitles">
                    <template v-if="canUseAiTranscript">
                        <div class="table_title section-head d-flex align-center justify-space-between">
                            <h3>
                                {{ $store.getters.t ? $store.getters.t('ai.subtitle.section_title') : 'AI 자막' }}
                            </h3>

                            <v-chip
                                small
                                pill
                                :ripple="false"
                                :class="chipClass"
                                >
                                <!-- 실패 상태일 때만 ! 아이콘을 표시하고, 그 외에는 이미지 표시 -->
                                <template v-if="aiStatus !== 'failed'">
                                    <v-img :src="aiImg" :class="['ai-icon', iconClass]" contain></v-img>
                                </template>
                                
                                <template v-else>
                                    <v-icon small color="red">mdi-alert-circle-outline</v-icon> <!-- 실패 상태일 때만 ! 아이콘 표시 -->
                                </template>
                                <span class="px-1">{{ aistatusLabel }}</span>
                                </v-chip>
                        </div>

                        <!-- 생성 전 -->
                        <div v-if="aiStatus === 'before'">
                            <v-card outlined class="intro-card pa-5">
                                <div v-if="isNoAudioTranscriptError" class="no-audio-state text-center">
                                    <div class="no-audio-icon mb-3">
                                        <v-icon size="36" color="grey darken-1">mdi-volume-off</v-icon>
                                    </div>
                                    <div class="intro-title">
                                        {{ noAudioErrorMessage }}
                                    </div>
                                    <div class="intro-desc">
                                        {{ noAudioErrorHint }}
                                    </div>
                                </div>
                                <div v-else class="info-warp">
                                    <div class="intro-title">
                                        {{ $store.getters.t ? $store.getters.t('ai.subtitle.intro.title') : 'AI가 영상을 분석하여 자막을 생성합니다.' }}
                                    </div>
                                    <div class="intro-desc">
                                        {{ $store.getters.t ? $store.getters.t('ai.subtitle.intro.description') : '분석이 완료되면 타임라인에 맞춘 자막을 자동으로 제공합니다.' }}
                                    </div>
                                </div>
                                
                                <div class="actions">
                                    <TextButton
                                        :buttonText="$store.getters.t ? $store.getters.t('ai.subtitle.cta.generate') : '자막 생성하기'"
                                        isPrimary
                                        :loading="transcriptLoading"
                                        :disabled="transcriptLoading || isNoAudioTranscriptError"
                                        @click="triggerSubtitleGeneration"
                                        class="mr-2"
                                    />
                                    <TextButton
                                        :buttonText="$store.getters.t ? $store.getters.t('ai.subtitle.cta.upload_srt') : 'SRT 업로드'"
                                        :disabled="transcriptLoading"
                                        @click="onUploadSrtClick"
                                    />
                                    <input
                                        ref="srtFileInput"
                                        type="file"
                                        accept=".srt"
                                        style="display:none"
                                        @change="handleSrtFileSelected"
                                    />
                                </div>
                            </v-card>
                        </div>
                        <!-- 생성 중 -->
                        <div v-else-if="aiStatus === 'generating'">
                            <v-card outlined class="gen-card pa-5">
                            <div class="gen-head">
                                <div class="gen-title">
                                {{ $store.getters.t ? $store.getters.t('ai.subtitle.state.generating_title') : '자막 생성 중입니다...' }}
                                </div>
                                <div class="gen-sub">
                                    {{ $store.getters.t ? $store.getters.t('ai.subtitle.state.generating_hint') : '영상 길이와 음성 품질에 따라 시간이 다를 수 있어요.' }}
                                </div>
                            </div>

                            <div class="gen-body mt-4 d-flex align-center">
                                <div class="flex-grow-1">
                                    <div class="skeleton-line" />
                                    <div class="skeleton-line short" />
                                </div>
                            </div>
                            </v-card>
                        </div>

                        <!-- 생성 완료 -->
                        <div v-else>
                        <v-card outlined class="ai-card">
                            <!-- 아코디언 헤더 -->
                            <v-expansion-panels v-model="aiPanel" accordion flat>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                <div class="d-flex align-center" style="gap:8px;">
                                    <v-icon small>mdi-subtitles</v-icon>
                                    <span>{{ $store.getters.t ? $store.getters.t('ai.subtitle.view_edit') : '자막 보기/편집' }}</span>
                                </div>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content>
                                <!-- 상단 툴바 -->
                                <div class="toolbar d-flex align-center">
                                    <div class="format-toggle">
                                    <v-btn-toggle v-model="subtitleFormat" dense>
                                        <v-btn value="text">{{ $store.getters.t ? $store.getters.t('ai.subtitle.format.text') : '텍스트 형식' }}</v-btn>
                                        <v-btn value="srt">{{ $store.getters.t ? $store.getters.t('ai.subtitle.format.srt') : 'SRT 형식' }}</v-btn>
                                    </v-btn-toggle>
                                    </div>
                                    <div class="ml-auto d-flex">
                                    <TextButton class="mr-2"
                                        :buttonText="$store.getters.t ? $store.getters.t('ai.subtitle.srt.download') : 'SRT 다운로드'"
                                        :disabled="!srtExists || transcriptLoading"
                                        @click="downloadSrt"
                                    />
                                    <TextButton
                                        :buttonText="$store.getters.t ? $store.getters.t('삭제') : '삭제'"
                                        :disabled="!srtExists || transcriptLoading"
                                        @click="deleteSrt"
                                    />
                                    </div>
                                </div>

                                <!-- 텍스트 형식 -->
                                <div v-if="subtitleFormat === 'text'" class="cue-list">
                                    <div v-if="aiTextCues.length === 0" class="no-data-form">
                                        <v-icon small>mdi-alert-circle-outline</v-icon>
                                        {{ $store.getters.t ? $store.getters.t('ai.subtitle.empty') : '표시할 자막이 없습니다.' }}
                                    </div>
                                    <template v-else>
                                        <v-card
                                        v-for="(c, i) in aiTextCues"
                                        :key="'cue-'+i"
                                        outlined
                                        class="cue-card pa-3 mb-3"
                                        >
                                        <div class="d-flex">
                                            <div class="time-pill mr-3">{{ c.start }} ~ {{ c.end }}</div>
                                            <div class="cue-text">{{ c.text }}</div>
                                        </div>
                                        </v-card>
                                    </template>
                                </div>

                                <!-- SRT 형식 (흰색 텍스트) -->
                                <div v-else>
                                    <v-card v-if="aiTextCues.length" outlined class="pa-4 code-card">
                                        <pre class="mb-0 srt-pre" style="white-space:pre-wrap">{{ asSrtText(aiTextCues) }}</pre>
                                    </v-card>
                                    <div v-else class="no-data-form">
                                        <v-icon small>mdi-alert-circle-outline</v-icon>
                                        {{ $store.getters.t ? $store.getters.t('ai.subtitle.empty') : '표시할 자막이 없습니다.' }}
                                    </div>
                                </div>

                                <!-- 편집 토글 -->
                                <div class="mt-4">
                                    <TextButtonBlock
                                        :buttonText="$store.getters.t ? $store.getters.t('ai.subtitle.editor.toggle') : '자막편집'"
                                        @click="toggleSubtitleEditor"
                                        width="100%"
                                        :disabled="transcriptLoading || aiTextCues.length === 0"
                                    />
                                </div>

                                <!-- 편집기 -->
                                <div v-show="showSubtitleEditor" class="subtitle-editor mt-3">
                                    <v-card
                                    v-for="(row, idx) in editCues"
                                    :key="'edit-'+idx"
                                    outlined
                                    class="edit-row pa-3 mb-3"
                                    >
                                    <div class="edit-grid">
                                        <!-- 시간 -->
                                        <div class="time-group">
                                        <div>
                                            <div class="label-sm">
                                                {{ $store.getters.t ? $store.getters.t('ai.subtitle.editor.start_label') : '시작' }}
                                            </div>
                                            <AppTextField :value="row.start" @input="val => onTimeInput(idx,'start',val)" />
                                        </div>
                                        <div>
                                            <div class="label-sm">
                                                {{ $store.getters.t ? $store.getters.t('ai.subtitle.editor.end_label') : '종료' }}
                                            </div>
                                            <AppTextField :value="row.end" @input="val => onTimeInput(idx,'end',val)" />
                                        </div>
                                        </div>

                                        <!-- 텍스트 -->
                                        <div class="text-group">
                                            <div class="label-sm">
                                                {{ $store.getters.t ? $store.getters.t('ai.subtitle.editor.caption_label') : '자막' }}
                                            </div>
                                            <AppTextField :value="row.text" @input="val => row.text = (val)" />
                                        </div>

                                        <!-- 액션 (아이콘 버튼 + 아웃라인 + 툴팁) -->
                                        <div class="action-group">
                                        <!-- 분할 -->
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs" v-on="on"
                                                outlined
                                                class="action-icon"
                                                aria-label="분할"
                                                @click="splitCue(idx)"
                                            >
                                                <v-icon small>mdi-content-cut</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>{{ $store.getters.t ? $store.getters.t('분할') : '분할' }}</span>
                                        </v-tooltip>

                                        <!-- 추가 (현재 행 아래에 추가) -->
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs" v-on="on"
                                                outlined
                                                class="action-icon"
                                                aria-label="추가"
                                                @click="addCueBelow(idx)"
                                            >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>{{ $store.getters.t ? $store.getters.t('추가') : '추가' }}</span>
                                        </v-tooltip>

                                        <!-- 다음과 병합 -->
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs" v-on="on"
                                                outlined
                                                class="action-icon"
                                                aria-label="다음과 병합"
                                                @click="mergeWithNext(idx)"
                                            >
                                                <v-icon>mdi-call-merge</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>{{ $store.getters.t ? $store.getters.t('다음과 병합') : '다음과 병합' }}</span>
                                        </v-tooltip>

                                        <!-- 삭제 -->
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                v-bind="attrs" v-on="on"
                                                outlined
                                                class="action-icon action-icon--danger"
                                                aria-label="삭제"
                                                @click="deleteCue(idx)"
                                            >
                                                <v-icon>mdi-delete-outline</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>{{ $store.getters.t ? $store.getters.t('삭제') : '삭제' }}</span>
                                        </v-tooltip>
                                        </div>

                                    </div>
                                    </v-card>

                                    <!-- 하단 개별 추가 버튼은 제거됨 -->
                                    <div class="d-flex mt-4">
                                    <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" :width="'49%'" class="mr-2" @click="cancelEditor" />
                                    <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('저장') : '저장'" :width="'49%'" isPrimary @click="saveEditor" />
                                    </div>
                                </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card>
                        </div>
                        <div v-if="transcriptError && !isNoAudioTranscriptError" class="error-text mt-3">{{ transcriptError }}</div>
                    </template>
                    <template v-else>
                        <v-card outlined class="pa-8 text-center ai-locked-card">
                            <v-icon size="48" color="grey darken-1" class="mb-4">mdi-lock-outline</v-icon>
                            <h3 class="mb-2">
                                {{ $store.getters.t ? $store.getters.t('ai.subtitle.locked.title') : '현재 무료 플랜에서는 AI 자막 기능이 제공되지 않습니다.' }}
                            </h3>
                            <p class="mb-0">
                                {{ $store.getters.t ? $store.getters.t('ai.subtitle.locked.description') : '상위 플랜으로 전환하면 자동 자막 생성과 편집 도구를 사용할 수 있습니다.' }}
                            </p>
                        </v-card>
                    </template>
                </div>


                <div class="ml-5 mt-5">
                    <h3 class="table_title">
                        <!-- 영상 상세 정보 -->
                        {{ $store.getters.t('인코딩 정보') }}
                    </h3>

                    <v-simple-table>
                        <template>
                            <thead>

                                <!-- <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        시간
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span>{{  assetInfo.runtime }}</span>.000
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3">
                                        사이즈
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ size }}</span>
                                    </th>
                                </tr> -->
                                <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        {{ $store.getters.t('인코딩 정보') }}
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span class="mr-2">{{ $store.getters.t('원본') }}</span>
                                        <TextButton class="mr-5" :disabled="type == null ? true : false" :buttonText="$store.getters.t ? $store.getters.t('보기') : '보기'" :xsmall="true" @click="showOriginInfo()"/>
                                    <template v-for="(item, index) in encodeList">
                                        <span :key="index" class="mr-5">
                                            <span class="mr-2">{{ item }}</span>
                                            <TextButton :buttonText="$store.getters.t('보기')" :xsmall="true" @click="showInfo(item, index)"/>
                                        </span>
                                    </template>
                                </th>
                                </tr>

                            </thead>
                        </template>
                    </v-simple-table>
                </div>

                <div class="ml-5 mt-8">
                    <h3 class="table_title">
                        {{ $store.getters.t('파일 메타데이터') }}
                    </h3>
                    <v-simple-table>
                        <template>
                            <thead>
                                <tr>
                                    <th class="thead_custom_left thead_custom_top pa-3">
                                        {{ $store.getters.t('시간') }}
                                    </th>
                                    <th class="thead_custom_right thead_custom_top pa-3">
                                        <span>{{  assetInfo.runtime }}</span>.000
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        {{ $store.getters.t('해상도') }}
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ metaInfo.resolution }}</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        {{ $store.getters.t('코덱') }}
                                    </th>
                                    <th class="thead_custom_right pa-3" style="height: 54px;">
                                        <span>{{ metaInfo.codec }}</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        {{ $store.getters.t('전송률') }}
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ metaInfo.bitrate }}</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="thead_custom_left pa-3" style="height: 54px;">
                                        {{ $store.getters.t('파일 크기') }}
                                    </th>
                                    <th class="thead_custom_right pa-3">
                                        <span>{{ metaInfo.size }}</span>
                                    </th>
                                </tr>


                            </thead>
                        </template>
                    </v-simple-table>
                </div>
            <!-- Social Upload History (Card list) -->
            <div class="ml-5 mt-8 ai-subtitles social-history-section">
                <div class="table_title section-head">
                    <h3>{{ $store.getters.t ? $store.getters.t('social.history.title') : '소셜 미디어 업로드 이력' }}</h3>
                </div>

            <template v-if="canUseSocialPublish">
                <div v-if="socialHistoryLoading" class="no-data-form">
                    <v-icon small>mdi-alert-circle-outline</v-icon>
                    {{ $store.getters.t ? $store.getters.t('social.history.loading') : '소셜 업로드 이력을 불러오는 중입니다.' }}
                </div>

                <div v-else-if="hasSocialHistory" class="su-history-list">
                    <v-card
                        v-for="(row, i) in socialHistory"
                        :key="'soc-card-'+i"
                        outlined
                        class="su-history-item"
                    >
                        <div class="su-history-inner">
                            <div class="su-left">
                                <div class="sm-avatar-wrap mr-3">
                                    <v-img
                                        :src="row.thumbnail || defaultSocialThumb"
                                        width="36"
                                        height="36"
                                        class="sm-avatar"
                                        contain
                                    />
                                    <v-img
                                        :src="getPlatformIcon(row)"
                                        width="16"
                                        height="16"
                                        class="platform-badge"
                                        contain
                                    />
                                </div>
                                <div class="channel-meta">
                                    <div class="channel-name one-line" :title="row.channel">{{ row.channel }}</div>
                                    <div class="channel-links">
                                        <div class="channel-link-row">
                                            <span class="channel-link-label">
                                                {{ $store.getters.t ? $store.getters.t('social.history.channel_url_label') : '채널 URL' }}:
                                            </span>
                                            <template v-if="row.channelUrl">
                                                <a
                                                    :href="formatLinkHref(row.channelUrl)"
                                                    class="channel-link"
                                                    target="_blank"
                                                    rel="noopener"
                                                >
                                                    {{ truncateLinkText(row.channelUrl) }}
                                                </a>
                                            </template>
                                            <span v-else>-</span>
                                        </div>
                                        <div
                                            class="channel-link-row"
                                            v-if="row.videoUrl"
                                        >
                                            <span class="channel-link-label">
                                                {{ row.videoLabel }}:
                                            </span>
                                            <a
                                                :href="formatLinkHref(row.videoUrl)"
                                                class="channel-link"
                                                target="_blank"
                                                rel="noopener"
                                            >
                                                {{ truncateLinkText(row.videoUrl) }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="su-right">
                                <v-chip small :color="row.chipColor" dark class="mr-3">
                                    {{ row.statusLabel }}
                                </v-chip>
                                <div class="posted-at">{{ row.postedAt }}</div>
                            </div>
                        </div>
                    </v-card>
                </div>

                <div v-else class="no-data-form">
                    <v-icon small>mdi-alert-circle-outline</v-icon>
                    {{ socialHistoryEmptyMessage }}
                </div>
            </template>

            <div v-else class="social-lock-card d-flex align-center">
                <v-icon size="36" color="#6b7280" class="mr-3">mdi-lock-outline</v-icon>
                <div>
                    <h4 class="mb-1">{{ $store.getters.t ? $store.getters.t('social.history.locked.current_plan') : '현재 요금제에서는 소셜 업로드 로그가 제공되지 않습니다.' }}</h4>
                    <p class="mb-0">{{ $store.getters.t ? $store.getters.t('social.history.locked.plan_hint') : '요금제를 업그레이드하면 채널별 기록과 상태를 확인할 수 있습니다.' }}</p>
                </div>
            </div>

            </div>
            
            </v-col>
        </v-row>
            <!-- 삭제 확인 modal -->
            <AppDialog :value="delConfirm" :persistent="true" @input="delConfirm = $event">
                    <template v-slot:title>
                        <span>{{ $store.getters.t('섬네일 삭제') }}</span>
                    </template>
                
                    <!-- <template v-slot:close>
                        <div style="float: right;">
                            <v-icon small @click="closeDialog('delConfirm')">mdi-close</v-icon>
                        </div>
                    </template> -->
                
                
                <template v-slot:content>
                <span>{{ $store.getters.t('선택한 섬네일 이미지 파일을 삭제하시겠습니까?') }}</span>
                </template>
                <template v-slot:actions>
                    <!-- <v-btn @click="deleteThumbnail(selIdx)">삭제</v-btn> -->
                    <TextButtonBlock :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" @click="closeDialog('delConfirm')" />
                    <TextButtonBlock :loading="tbloading" :buttonText="$store.getters.t ? $store.getters.t('삭제') : '삭제'" @click="deleteThumbnail(selIdx)" isPrimary />
                </template>
            </AppDialog>
            <v-dialog v-model="showSrtUploadConfirm" max-width="420">
                <v-card class="pa-6 text-center">
                    <v-icon size="48" color="grey darken-1" class="mb-4">mdi-alert-outline</v-icon>
                    <h3 class="mb-2">
                        {{ $store.getters.t ? $store.getters.t('ai.subtitle.srt_upload.confirm_title') : 'SRT 업로드' }}
                    </h3>
                    <p class="mb-6">
                        {{ $store.getters.t ? $store.getters.t('ai.subtitle.srt_upload.confirm_message') : 'SRT 파일을 업로드하면 기존 자막이 대체됩니다. 계속하시겠습니까?' }}
                    </p>
                    <div class="d-flex justify-center">
                        <TextButtonBlock
                            class="mr-2"
                            :buttonText="$store.getters.t ? $store.getters.t('common.action.cancel') : '취소'"
                            @click="showSrtUploadConfirm = false"
                        />
                        <TextButtonBlock
                            :buttonText="$store.getters.t ? $store.getters.t('common.action.upload') : '업로드'"
                            isPrimary
                            @click="confirmSrtUpload"
                        />
                    </div>
                </v-card>
            </v-dialog>
            <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

    </div>
</template>

<style>
.cont_title {margin-top: 20px;padding-bottom: 10px;border-bottom: 1px solid #000;font-size: 18px;}
.thumnail_box {margin-top: 10px;}
.thumnail_upload {width: 100%; height: 48px;border: 1px dotted #bbb;text-align: center;font-size: 10px;color: #bbb;}
.thumnail_upload span {color: #bbb;}
.table_title {font-size: 18px;padding-bottom: 10px; width:100%;}
.table_title h3 { font-size: 16px; }
.modify_left_wraper {width: 500px !important;}
.right_wraper {width: 100%;}
.text_box {word-break:break-all;}
.table_text {background: #fff;}

.subtitle-editor { border: 1px solid #eee; background: #fafafa; padding: 16px; border-radius: 6px; }

.ai-subtitles .section-head {
  display:flex; align-items:center; gap:10px; margin-bottom:10px;
}

.ai-subtitles .table_title { width: 100%; border-color: #0b1220; }
.ai-locked-card { background-color: #f5f7fb; border-color: #e5e7eb; }
.no-audio-state {
  text-align:center;
  background:#f9fafb;
  border:1px dashed #e5e7eb;
  border-radius:12px;
  padding:16px;
  margin-bottom:16px;
}
.no-audio-state .intro-title {
  font-weight:600;
}
.no-audio-state .intro-desc {
  color:#6b7280;
  margin-top:4px;
}
.no-audio-icon {
  width:48px;
  height:48px;
  border-radius:9999px;
  background:#eef2ff;
  display:flex;
  align-items:center;
  justify-content:center;
  margin:0 auto;
}
.state-chip { background:#f3f4f6 !important; color:#374151 !important; }
.state-chip.warning { background:#fff7ed !important; color:#9a3412 !important; border:1px solid #fed7aa !important; }
.state-chip.success { background:#ecfdf5 !important; color:#065f46 !important; border:1px solid #a7f3d0 !important; }

.intro-card { border-radius:12px; display: flex; justify-content: space-between; align-items: center; }
.intro-title { font-weight:700; color:#111827; font-size:16px; }
.intro-desc { color:#6b7280; font-size:13px; margin-top:6px; }

.gen-card { border-radius:12px; }
.gen-head .gen-title { font-weight:700; color:#111827; }
.gen-head .gen-sub { color:#6b7280; font-size:13px; margin-top:4px; }
.skeleton-line {
  height:12px; border-radius:6px; background:linear-gradient(90deg, #f3f4f6, #e5e7eb, #f3f4f6);
  background-size:200% 100%; animation:skeleton 1.2s ease-in-out infinite;
  margin-bottom:10px;
}
.skeleton-line.short { width:60%; }
@keyframes skeleton { 0%{background-position:200% 0;} 100%{background-position:-200% 0;} }

.toolbar { margin-bottom:12px; }

/* 카드 래퍼 */
.ai-card { border-radius: 12px; }

/* 생성 전 카드 */
.intro-card { border-radius:12px; display:flex; align-items:center; justify-content:space-between; gap:16px; }
.intro-card .info-warp { min-width: 0; }
.intro-card .intro-title { font-weight:700; color:#111827; font-size:16px; }
.intro-card .intro-desc { color:#6b7280; font-size:13px; margin-top:6px; }
.intro-card .actions { flex:0 0 auto; }

/* 생성 중 */
.gen-card { border-radius:12px; }
.gen-head .gen-title { font-weight:700; color:#111827; }
.gen-head .gen-sub { color:#6b7280; font-size:13px; margin-top:4px; }
.skeleton-line {
  height:12px; border-radius:6px;
  background:linear-gradient(90deg, #f3f4f6, #e5e7eb, #f3f4f6);
  background-size:200% 100%;
  animation:skeleton 1.2s ease-in-out infinite;
  margin-bottom:10px;
}
.skeleton-line.short { width:60%; }
@keyframes skeleton { 0%{background-position:200% 0;} 100%{background-position:-200% 0;} }

/* 목록 보기 */
.cue-list .cue-card { border-radius:12px; }
.time-pill {
  padding:6px 10px; border-radius:9999px; font-size:12px; font-weight:700;
  background:#eef2ff; color:#3730a3; white-space:nowrap;
}
.cue-text { color:#111827; line-height:1.55; }

/* SRT 보기: 어두운 배경 + 흰 글자 */
.code-card { border-radius:12px; background:#0b1220 !important;max-height: 270px; overflow-y: auto; }
.code-card .srt-pre { color:#ffffff;white-space: pre-wrap; }

/* Chrome, Edge, Safari */
.code-card::-webkit-scrollbar {
  width: 6px; /* 스크롤바 두께 */
}

.code-card::-webkit-scrollbar-track {
  background: transparent; /* 트랙은 투명하게 */
}

.code-card::-webkit-scrollbar-thumb {
  background-color: #5f5f5f;
  border-radius: 3px;
}

/* 편집기 정렬 */
.subtitle-editor .edit-row { border-radius:12px; }
.edit-grid {
  display:grid;
  grid-template-columns: 260px 1fr auto; /* 시간 / 텍스트 / 액션 */
  grid-column-gap: 12px;
  align-items: center;
}
.time-group {
  display:grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
}
.text-group { width:100%; }
.action-group { display:flex; align-items:center; flex-wrap:wrap; gap: 8px; margin-top: 10px; }
.label-sm { font-size:12px; color:#6b7280; margin-bottom:4px; }

@media (max-width: 960px) {
  .edit-grid { grid-template-columns: 1fr; grid-row-gap: 12px; }
  .action-group { justify-content: flex-end; }
}

.action-icon { padding: 0 !important; min-width: 36px !important; border-color: #ccc; }
.empty-dashed {
  border: 1px dashed #ddd;
  border-radius: 6px;
}

.error-text {
  color: #d32f2f;
  font-size: 13px;
}

.su-history-item {
  border-radius: 10px !important;
}

.su-history-list {
    display: grid;
    gap: 8px;
}

.su-history-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}

.su-left {
  display: flex;
  align-items: center;
  min-width: 0; /* ellipsis 위해 */
}

.platform-badge {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  background: none;
}

.channel-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
}

.channel-meta {
  min-width: 0;
}

.channel-name {
  font-weight: 700;
  color: #111827;
}

.channel-links {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.channel-link-row {
  font-size: 12px;
  color: #4b5563;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.channel-link-label {
  font-weight: 400;
  color: #9ca3af;
}

.channel-links .channel-link {
  color: #9ca3af;
  text-decoration: none;
  word-break: break-all;
  font-weight: 400 !important;
  transition: color 0.2s ease;
}

.channel-links .channel-link:hover {
  color: #6b7280;
  text-decoration: underline;
}

.su-right {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.posted-at {
  font-size: 13px;
  color: #374151;
}

/* 공통 */
.one-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-dashed {
  border: 1px dashed #ddd;
  border-radius: 6px;
}

/* 반응형: 좁은 화면에서 우측 영역 줄바꿈 여지 */
@media (max-width: 640px) {
  .su-history-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .su-right {
    width: 100%;
    justify-content: space-between;
  }
}

.sm-avatar-wrap {
  position: relative;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
}

.sm-avatar {
  border-radius: 50%;
  overflow: hidden;
}

.platform-badge {
  position: absolute;
  right: -18px;
  bottom: -2px;
  width: 16px !important;
  height: 16px !important;
  background: none;
}


.ai-icon {  width: 18px; height: auto; filter: brightness(1); transition: filter 0.3s ease; }

/* ▸ 생성전: 흰 배경 + 회색 보더 + 진한 회색 텍스트 */
.chip--idle {
  background: #ffffff !important;
  border: 1px solid #cbd5e1 !important;
  color: #374151 !important;
}
.chip--gen {
  background: #f3f4f6 !important;
  border: 1px solid #e5e7eb !important;
  color: #374151 !important;
}
.chip--done {
  background: linear-gradient(90deg, #3b82f6 0%, #6366f1 100%) !important;
  color: #ffffff !important;
  border: none !important;
}

.chip--failed {
  background-color: #ffebee!important;
  color: #f44336!important;
  border: 1px solid #f44336!important;
}

.failed-icon {
  font-size: 22px;
  color: #f44336;  /* 빨간색 */
}

.chip--done .ai-icon {
  filter: brightness(0) invert(1);  /* 흰색 처리 */
}

/* 아이콘 반짝반짝(글로우 + 미세 확대/축소) */
@keyframes twinkleGlow {
  0%, 100% {
    filter: brightness(1) drop-shadow(0 0 0 rgba(59,130,246,0));
    transform: scale(1);
  }
  50% {
    filter: brightness(1.35) drop-shadow(0 0 6px rgba(59,130,246,0.55));
    transform: scale(1.06);
  }
}
.twinkle {
  animation: twinkleGlow 1.1s infinite ease-in-out;
}

/* 다크테마 대비(선택) */
.theme--dark .chip--idle {
  background: #111827; color: #e5e7eb; border-color: #374151;
}
.theme--dark .chip--gen {
  background: #1f2937; color: #e5e7eb; border-color: #374151;
}
.theme--dark .chip--done {
  background-image: linear-gradient(90deg, #2563eb 0%, #4f46e5 100%); color: #fff;
}
.social-locked-card {
  background: #f9fafb;
  border-color: #e5e7eb;
  color: #4b5563;
}
.social-history-section {
  position: relative;
}
.social-lock-card {
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  padding: 20px;
  background: #f3f4f6;
  color: #374151;
}

.no-data-form { color:#888; padding: 24px;font-size: 14px; display: flex; gap:4px; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 2px;}

</style>
